module.exports = __webpack_public_path__ + "images/YammerLogo-dccc609aadb29dbd2a112ad1242d3f59.svg";